import { useState } from 'react'
import { useMutation } from 'react-apollo-hooks'
// import { useScript } from 'the-platform'
import useScript from './useScript'
import _get from 'lodash/get'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'

const useOmiseOffline = (method, publicKey, onError) => {
  // useScript({ src: 'https://cdn.omise.co/omise.js.gz' })
  const [loaded, error] = useScript('https://cdn.omise.co/omise.js.gz')
  error && console.error(error)
  const [paymentLoading, setPaymentLoading] = useState(false)
  const payRegistration = useMutation(payRegistrationMutation)
  const pay = async (sourceType, registration, src) => {
    setPaymentLoading(true)
    // eslint-disable-next-line no-undef
    Omise.setPublicKey(publicKey)
    try {
      const source = await new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        Omise.createSource(sourceType, {
          currency: 'thb',
          ...src,
          amount: Math.round(src.amount * 100)
        }, (statusCode, response) => {
          if (statusCode !== 200) {
            return reject(response.message)
          }
          return resolve(response)
        })
      })

      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method,
            data: {
              omise: {
                source: { id: source.id },
                returnUri: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
              }
            }
          }
        }
      })
      const references = _get(
        data,
        'payRegistration.record.data.omise.charge.source.references'
      )
      return references
    } catch (err) {
      onError(err)
    } finally {
      setPaymentLoading(false)
    }
  }
  return [loaded, paymentLoading, pay]
}

export default useOmiseOffline



// WEBPACK FOOTER //
// ./src/App/hooks/useOmiseOffline.js